import { http } from "helpers/Http";
import { IPaymentTypeList } from "types/Payment";

export async function fetchAPIPaymentType(id: number): Promise<IPaymentTypeList> {
    id = id ?? -1;
    const url = `places/${id}/payments`;

    //console.log(url)

    const data = http.get(url).then((response) => response.data);
    return data;
}